export const GET_CATEGORIES = 'GET_CATEGORIES';

export const GET_ALL_POSTS = 'GET_ALL_POSTS';
export const GET_POST = 'GET_POST';
export const CREATE_POST = 'ADD_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';

export const GET_POST_COMMENTS = 'GET_POST_COMMENTS';
export const GET_COMMENT = 'GET_COMMENT';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';

// UI ACTION TYPES
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';

export const SET_POSTS_LOADING = 'SET_POSTS_LOADING';
export const UNSET_POSTS_LOADING = 'UNSET_POSTS_LOADING';

export const SET_COMMENTS_LOADING = 'SET_COMMENTS_LOADING';
export const UNSET_COMMENTS_LOADING = 'UNSET_COMMENTS_LOADING';
